import axios from "axios";

export const salesService = {
    async getSales(params) {
        return (await axios.get('/sales-channels/', {
            params
        })).data
    },
}